// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__Rvhto","totalDisplay":"Pagination_totalDisplay__Jf2qj"};